import React, { useEffect, useState } from 'react';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates_bus';
import useHttp from '../../../../hook/use-http';
import styles from './MileageSaarathi.module.css';

function EnergyEfficiencyStats({ filterdata, onValueUpdate }) {
  const { sendReq: fetchData } = useHttp();

  const [averageEfficiency, setAverageEfficiency] = useState('--');
  const [targetEfficiency, setTargetEfficiency] = useState('--');
  const [efficiencyScore, setEfficiencyScore] = useState('--');

  const getFirstValueFromValues = (valuesObj) => {
    if (!valuesObj) return 0;
    const firstKey = Object.keys(valuesObj)[0];
    return firstKey ? valuesObj[firstKey] : 0;
  };

  useEffect(() => {
    // Average Efficiency (from median_kwh/km)
    fetchData(
      {
        url: API_URL_MAIN + 'mileage_sarathi/fleet_summary_Average_Energy_Efficiency', // Corrected URL
        method: 'POST', // Important to POST
        body: { filterdata },
      },
      (data) => {
        const values = data?.['Average_Energy_Efficiency']?.values?.["50.0"];
        const value = values
        setAverageEfficiency(`${value.toFixed(2)} KWh/Km`);
        onValueUpdate?.("Average_Energy_Efficiency", value.toFixed(2));
      }
    );

    // Target Efficiency (from Target_Energy_Efficiency)
    fetchData(
      {
        url: API_URL_MAIN + 'mileage_sarathi/fleet_summary_target_energy_efficiency',
        method: 'POST',
        body: { filterdata },
      },
      (data) => {
        const values = data?.Target_Energy_Efficiency?.values?.["50.0"];
        const value = values
        setTargetEfficiency(`${parseFloat(value).toFixed(2)} KWh/Km`);
        onValueUpdate?.("Target_Energy_Efficiency", parseFloat(value).toFixed(2));
      }
    );

    fetchData(
      {
        url: API_URL_MAIN + 'mileage_sarathi/fleet_summary_energy_efficiency_score',
        method: 'POST',
        body: { filterdata },
      },
      (data) => {
        const values = data?.Energy_Efficiency_Score?.value
        const value = values;
        setEfficiencyScore(`${parseFloat(value).toFixed(2)}`);
        onValueUpdate?.("Energy_Efficiency_Score", parseFloat(value).toFixed(2));
      }
    );

    // Efficiency Score — API not yet available

  }, [filterdata, fetchData]);

  return (
    <div className="row mt-3">
      <div className="col-md-12">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <span className={`me-2 ${styles.efficiency_paratext}`}>Average Energy Efficiency:</span>
          <span className={`me-4 px-2 py-1 rounded ${styles.efficiency_paranum}`}>
            {averageEfficiency}
          </span>

          <span className={`me-2 ${styles.efficiency_paratext}`}>Target Energy Efficiency:</span>
          <span className={`me-4 px-2 py-1 rounded ${styles.efficiency_paranum}`}>
            {targetEfficiency}
          </span>

          <span className={`me-2 ${styles.efficiency_paratext}`}>Energy Efficiency Score:</span>
          <span className={`me-4 px-2 py-1 rounded ${styles.efficiency_paranum}`}>
            {efficiencyScore}
          </span>
        </div>
      </div>
    </div>
  );
}

export default EnergyEfficiencyStats;
